var fathersDayNavSwiper = new Swiper(".fathersDayNavSwiper", {
    slidesPerView: 4,
    spaceBetween: 48,
    on: {
        init: function () {
            if ($(window).width() <= 768) {
                this.params.spaceBetween = 6;
                this.params.slidesPerView = 2.8;
                this.update();
            }
        },
        resize: function (swiper) {
            if ($(window).width() <= 768) {
                this.params.spaceBetween = 6;
                this.params.slidesPerView = 2.8;
                this.update();
            }
        }
    }
});

$('.fathersDayNavSwiper .nav-item').click(function(){
  
  let index = $(this).index();
  console.log(index);
  $(this).addClass('active').siblings().removeClass('active');
  fathersDayNavSwiper.slideTo(index, 1000, false);
})

var fathersDayCard1Swiper = new Swiper(".fathersDayCard1Swiper", {
    pagination: {
        el: ".fathersDayCard1Swiper .swiper-pagination",
    },
});

var fathersdaySwiper2 = new Swiper(".fathersdaySwiper2", {
    slidesPerView: isMobile() ? 1.2 : 2,
    spaceBetween: isMobile() ? 16 : 32,
    centeredSlides: true,
    centeredSlidesBounds: true,
    loop: true,
    scrollbar: {
        el: ".fathersdaySwiper2 .swiper-scrollbar",
        hide: false,
    },
});

var fathersDaySwiper3 = new Swiper(".fathersdaySwiper3", {
    slidesPerView: isMobile() ? 1.2 : 2,
    spaceBetween: isMobile() ? 16 : 32,
    centeredSlides: true,
    centeredSlidesBounds: true,
    loop: true,
    scrollbar: {
        el: ".fathersdaySwiper3 .swiper-scrollbar",
        hide: false,
    },
});

let fatherDayYoutubeVideo = document.getElementById('youtubeVideo')
$('.play-button').click(function () {
  let video = $(this).data('url');
  $('.tb-video-window').show();
  $('body').addClass('over-hidden');
  fatherDayYoutubeVideo.setAttribute('src', video + '?autoplay=1')
})
$('.tb-video-close').click(function () {
  $('body').addClass('over-auto');
  $('.tb-video-window').hide();
  fatherDayYoutubeVideo.setAttribute('src', '')
})


var recommendSwiper = new Swiper(".recommendSwiper", {
    slidesPerView: isMobile() ? 1.4 : 1,
    spaceBetween: isMobile() ? 2 : 12,
    loop: isMobile() ? true : false,
    centeredSlides: true,
    centeredSlidesBounds: true,
    on: {
      slideChangeTransitionEnd: function(){
        let index = this.activeIndex;
        $('.recommend-nav-box .nav-item').eq(index).addClass('active').siblings().removeClass('active');
      },
    }
  });
  
  $('.recommend-nav-box .nav-item').click(function(){
    let index = $(this).index();
    $(this).addClass('active').siblings().removeClass('active');
    recommendSwiper.slideTo(index, 1000, false);
  })

